export default __webpack_public_path__ + "static/media/hearts_background.2b256cf6.png";